import Axios from "axios";

export interface Waffles {
  flags: { [key: string]: boolean };
  switches: {
    stakeholder: boolean;
    custom_deposit_method: boolean;
    "lot-ids": boolean;
    "show-auction-id": boolean;
    "manage-users-page": boolean;
    "wings-integration": boolean;
    remove_deposit: boolean;
    deposit_refund_reason: boolean;
    delete_bid_rework: boolean;
    delete_bid_email: boolean;
    block_user_rework: boolean;
    block_user_email: boolean;
    unblock_user_rework: boolean;
    unblock_user_email: boolean;
  };
}

export async function getWaffles() {
  const response = await Axios.get<Waffles>("/api/waffle/");
  return response.data;
}
